import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles({
  field: {
    width: "99%",
    maxWidth: "700px",
  },
  helperText: {
    flexGrow: 50,
  },
  limitWarning: {
    color: "#c53929",
  },
  helperTextRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 12,
    color: "rgba(0, 0, 0, 0.54)",
    width: "99%",
  },
  helperTextContainer: {
    maxWidth: "75%",
  },
  questionWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  answer: {
    textAlign: "center",
    width: "100%",
  },
  textBottomContainer: {
    display: "flex",
    justifyContent: "flex-end",
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: 13,
    marginTop: "-7px",
    width: "99%",
  },
  counterBox: {
    marginLeft: 15,
    minWidth: 49,
    textAlign: "right",
  },
  textArea: {
    width: "100%",
    minHeight: "100px !important",
    borderRadius: 4,
    border: "1px solid #dadce0",
    fontSize: 16,
    paddingLeft: 10,
    "&:focus": {
      outline: "none !important",
      border: (props) => `1px solid ${props.currentTheme.primaryColor}`,
    },
  },
});

export default useStyles;
